import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IMarketTrand } from '../../types/redux/marketTrand';
import { ERoomsCount } from '@cian/valuation-web-charts-widget';
import { EPeriod } from '../../repositories/valuation-offer-history/v1/get-market-trand';

export enum EActionTypes {
  GetAvailableFilters = 'marketTrand/getAvailableFilters',
  GetMarketTrend = 'marketTrand/getMarketTrend',
  GetSupplyDemand = 'marketTrand/getSupplyDemand',
  SetAvailableFiltersLoading = 'marketTrand/setAvailableFiltersLoading',
  SetMarketTrendLoading = 'marketTrand/setMarketTrendLoading',
  SetSupplyDemandLoading = 'marketTrand/setSupplyDemandLoading',
  SetRoomsCountInFilter = 'marketTrand/setRoomsCountInFilter',
  SetPeriodInFilter = 'marketTrand/setPeriodInFilter',
}

export const getAvailableFiltersForMarketTrand = actionGenerator<
  EActionTypes.GetAvailableFilters,
  IMarketTrand['filters']
>(EActionTypes.GetAvailableFilters);
export const getMarketTrand = actionGenerator<EActionTypes.GetMarketTrend, IMarketTrand['marketTrendData']>(
  EActionTypes.GetMarketTrend,
);
export const getSupplyDemand = actionGenerator<EActionTypes.GetSupplyDemand, IMarketTrand['supplyDemandData']>(
  EActionTypes.GetSupplyDemand,
);

export const setAvailableFiltersLoading = actionGenerator<EActionTypes.SetAvailableFiltersLoading, boolean>(
  EActionTypes.SetAvailableFiltersLoading,
);
export const setMarketTrandLoading = actionGenerator<EActionTypes.SetMarketTrendLoading, boolean>(
  EActionTypes.SetMarketTrendLoading,
);
export const setSupplyDemandLoading = actionGenerator<EActionTypes.SetSupplyDemandLoading, boolean>(
  EActionTypes.SetSupplyDemandLoading,
);

export const setRoomsCountInFilter = actionGenerator<EActionTypes.SetRoomsCountInFilter, ERoomsCount>(
  EActionTypes.SetRoomsCountInFilter,
);
export const setPeriodInFilter = actionGenerator<EActionTypes.SetPeriodInFilter, EPeriod>(
  EActionTypes.SetPeriodInFilter,
);

type TGetAvailableFiltersAction = ReturnType<typeof getAvailableFiltersForMarketTrand>;
type TGetMarketTrandAction = ReturnType<typeof getMarketTrand>;
type TGetSupplyDemandAction = ReturnType<typeof getSupplyDemand>;
type TSetAvailableFiltersLoadingAction = ReturnType<typeof setAvailableFiltersLoading>;
type TSetMarketTrandLoadingAction = ReturnType<typeof setMarketTrandLoading>;
type TSetSupplyDemandLoadingAction = ReturnType<typeof setSupplyDemandLoading>;
type TSetRoomsCountInFilterAction = ReturnType<typeof setRoomsCountInFilter>;
type TSetPeriodInFilterAction = ReturnType<typeof setPeriodInFilter>;

export type TMarketTrandActions =
  | TGetAvailableFiltersAction
  | TGetMarketTrandAction
  | TSetMarketTrandLoadingAction
  | TSetAvailableFiltersLoadingAction
  | TSetSupplyDemandLoadingAction
  | TSetRoomsCountInFilterAction
  | TSetPeriodInFilterAction
  | TGetSupplyDemandAction;
